import { getInfoAboutAdmin } from "../admin/asyncThunk";
import {
  register,
  logIn,
  logout,
  refresh,
  getProfile,
  getMe,
  updateProfile,
  changePassword,
  forgotPassword,
  resetPassword,
} from "./asyncThunk";
import { storageUtils } from "../../../utils/storage";

export const registerBuilder = (builder) => {
  builder.addCase(register.pending, (state) => {
    state.loginPending = true;
  });
  builder.addCase(register.fulfilled, (state, { payload }) => {
    state.loginPending = false;
    const { accessToken, user } = payload.data;
    const rememberMe = payload.rememberMe || true; // Default to true for registration

    // Update state
    state.token = accessToken;
    state.loggedIn = true;
    state.user = user;
    state.email = user.email;

    // Save to appropriate storage
    storageUtils.setAuthData('accessToken', accessToken, rememberMe);
    storageUtils.setAuthData('user', user, rememberMe);
  });
  builder.addCase(register.rejected, (state) => {
    state.loginPending = false;
  });
};

export const loginBuilder = (builder) => {
  builder.addCase(logIn.pending, (state) => {
    state.loginPending = true;
  });
  builder.addCase(logIn.fulfilled, (state, { payload }) => {
    state.loginPending = false;
    const { accessToken, user } = payload.data;
    const rememberMe = payload.rememberMe || false; // Use rememberMe from payload

    // Update state
    state.token = accessToken;
    state.loggedIn = true;
    state.user = user;
    state.email = user.email;

    // Save to appropriate storage based on rememberMe
    storageUtils.setAuthData('accessToken', accessToken, rememberMe);
    storageUtils.setAuthData('user', user, rememberMe);
  });
  builder.addCase(logIn.rejected, (state) => {
    state.loginPending = false;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.pending, (state) => {
    state.loggedIn = false;
    // Clear both storages immediately
    storageUtils.clearAllAuthData();
  });
  builder.addCase(logout.fulfilled, (state) => {
    state.loggedIn = false;
    state.user = null;
    state.token = null;
    state.email = "";
    // Clear both storages
    storageUtils.clearAllAuthData();
  });
  builder.addCase(logout.rejected, (state) => {
    state.loggedIn = false;
    state.user = null;
    state.token = null;
    state.email = "";
    // Clear both storages even if logout failed
    storageUtils.clearAllAuthData();
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.fulfilled, (state, action) => {
    const { accessToken } = action.payload;
    state.loggedIn = true;
    state.token = accessToken;
    
    // Update token in same storage where user data exists
    // Check if user exists in localStorage (remember me was on)
    const userInLocalStorage = localStorage.getItem('user');
    const rememberMe = !!userInLocalStorage;
    
    storageUtils.setAuthData('accessToken', accessToken, rememberMe);
  });
};

export const getProfileBuilder = (builder) => {
  builder.addCase(getProfile.fulfilled, (state, { payload }) => {
    state.user = payload.data.user;
    state.email = payload.data.user.email;
    
    // Update user in same storage where it exists
    const userInLocalStorage = localStorage.getItem('user');
    const rememberMe = !!userInLocalStorage;
    
    storageUtils.setAuthData('user', payload.data.user, rememberMe);
  });
};

export const getMeBuilder = (builder) => {
  builder.addCase(getMe.fulfilled, (state, { payload }) => {
    state.user = payload.data.user;
    state.email = payload.data.user.email;
    
    // Update user in same storage where it exists
    const userInLocalStorage = localStorage.getItem('user');
    const rememberMe = !!userInLocalStorage;
    
    storageUtils.setAuthData('user', payload.data.user, rememberMe);
  });
};

export const updateProfileBuilder = (builder) => {
  builder.addCase(updateProfile.fulfilled, (state, { payload }) => {
    state.user = payload.data.user;
    state.email = payload.data.user.email;
    
    // Update user in same storage where it exists
    const userInLocalStorage = localStorage.getItem('user');
    const rememberMe = !!userInLocalStorage;
    
    storageUtils.setAuthData('user', payload.data.user, rememberMe);
  });
};

export const changePasswordBuilder = (builder) => {
  builder.addCase(changePassword.fulfilled, (state) => {
    // Password changed successfully, no state change needed
  });
};

export const getInfoAboutAdminBuilder = (builder) => {
  builder.addCase(getInfoAboutAdmin.fulfilled, (state) => {
    state.loggedIn = true;
  });
  builder.addCase(getInfoAboutAdmin.rejected, (state) => {
    state.loggedIn = false;
  });
};

export const forgotPasswordBuilder = (builder) => {
  builder.addCase(forgotPassword.pending, (state) => {
    state.loading = true;
    state.error = null;
  });
  builder.addCase(forgotPassword.fulfilled, (state) => {
    state.loading = false;
    state.error = null;
  });
  builder.addCase(forgotPassword.rejected, (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  });
};

export const resetPasswordBuilder = (builder) => {
  builder.addCase(resetPassword.pending, (state) => {
    state.loading = true;
    state.error = null;
  });
  builder.addCase(resetPassword.fulfilled, (state) => {
    state.loading = false;
    state.error = null;
  });
  builder.addCase(resetPassword.rejected, (state, action) => {
    state.loading = false;
    state.error = action.error.message;
  });
};
